module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAMAAAB4vXe4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUxpcbzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7jjWnx4AAAARdFJOUwDohRIs1a7xkHBOXvrBmnez1KIHiwAAAH9JREFUKM+l0ssOgCAMRNEWBHlq+v8/a0FNjIFx4d2eDelA5KW3LjQunC7Ojj1eLhz2+CqpJ5kX1BfgWd0C728O8+h/vKKYnKDcfd5Jngx0Qxl6hudrB7LQdVMGzHqACryqb8C35/8YFD/+R/r4H33/MuXSF3RgnZYH67QMWIcOH0snOtYQK4UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/dir.png
// module id = 0JAa
// module chunks = 38